import { createStyles } from "@mantine/core";
import { ICustomCardProps } from "./types";
import objectPath from "object-path";

export const useStyles = createStyles(
  (theme, { borderColor }: Pick<ICustomCardProps, "borderColor">) => ({
    root: {
      borderColor:
        objectPath.get(theme, `colors.${borderColor}`) || borderColor,
    },
  }),
);
